<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      :height="tableHeight"
      size="small"
      class="bg-white"
      :loading="loading"
      resizable
      border
      @cell-click="groupClick"
    >
      <template v-slot:toolbar_form>
        <b-button-group size="sm">
          <b-button
            class="mr-2"
            variant="outline-success"
            @click="fromLoad('add')"
            v-if="allow('A')"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l("tips_add") || "新增" }}
          </b-button>
          <b-button
            variant="outline-success"
            @click="fromLoad('edit')"
            v-if="allow('A')"
            v-show="editBtn"
          >
            <b-icon-pencil></b-icon-pencil>
            {{ $l("tips_update") || "修改" }}
          </b-button>
        </b-button-group>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l("INDEX.table_label_no_data") || "暂无数据！" }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="50%"
    >
      <page-detail ref="form" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{
          $l("INDEX.btn_cancel") || "取 消"
        }}</el-button>
        <el-button type="primary" @click="save" size="small">{{
          $l("INDEX.btn_save") || "保 存"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  mounted() {
    console.log("tableData", this.tableData)
  },
  components: {
    PageDetail: () => import("./components/detail"),
  },
  created() {
    window.addEventListener("resize", this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight)
  },
  data() {
    return {
      tableHeight: 600,
      editBtn: false,
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => this.$emit("submit"),
        },
      },
      tableColumns: [
        {
          field: "seq",
          width: 50,
          align: "center",
          type: "seq",
        },
        {
          title: this.$l("form_label_groupName") || "评分组名称",
          field: "appraisalGroupName",
          minWidth: 270,
          align: "left",
          headerAlign: "left",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
          sortable: true,
          sortType: "string",
        },
      ],
      // 表单设置
      formOption: {
        title: "",
        dialogFormVisible: false,
      },
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 173
    },
    groupClick({ row }) {
      if (row) {
        this.params = {
          appraisalGroupCode: row.appraisalGroupCode,
        }
        this.editBtn = true
      } else {
        this.params = {
          appraisalGroupCode: "",
        }
        this.editBtn = false
      }
      this.$emit("groupClick", this.params)
    },
    // 加载表单
    fromLoad(ref) {
      const opt = {
        add: this.$l("tips_add") || "新增",
        edit: this.$l("tips_edit") || "编辑",
      }
      // 设置标题
      this.formOption.title = opt[ref]
      // 显示表单
      this.formOption.dialogFormVisible = true
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, this.params)
      }, 0)
    },
    save() {
      this.$refs.form.save()
    },
    saveSuccess() {
      this.cancel()
      this.$emit("submit")
    },
    cancel() {
      this.formOption.dialogFormVisible = false
      setTimeout(() => {
        this.$refs.form.init()
      }, 0)
    },
  },
}
</script>
